/**
 * GSB React Components Utilities
 */
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function getTitleField(entityDef) {
    if (!entityDef?.properties) {
        throw new Error("Entity definition properties are required");
    }
    const priority = [
        "title",
        "name",
        "label",
        "displayName",
        "fullName",
        "username",
        "code",
        "slug",
        "description",
    ];
    for (const key of priority) {
        const hasProperty = entityDef.properties.find((property) => property.name?.toLowerCase() === key.toLowerCase());
        if (hasProperty) {
            return hasProperty.name;
        }
    }
    return undefined; // Nothing reasonable found
}
// Export utilities here
//# sourceMappingURL=index.js.map